





























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import StatisticsConfig from "./data/StatisticsConfig";
import * as qlog from '@/data/QlogSchema';

import StatisticsConnectionRenderer from "@/components/stats/StatisticsConnectionRenderer.vue";

@Component({
    components: {
        StatisticsConnectionRenderer,
    },
})
export default class StatisticsRenderer extends Vue {
    @Prop()
    public config!: StatisticsConfig;

    protected get group() {
        return this.config.group;
    }

    protected get totalEventCount() {
        if ( !this.config.group ) {
            return -1;
        }
            
        let output = 0;

        for ( const trace of this.config.group!.getConnections() ){
            if ( !trace.wasAutoGenerated ) {
                output += trace.getEvents().length;
            }
        }

        return output;
    }

    protected get qlogns(){
        return qlog;
    }
}

